import { createContext } from 'react';
import { ContextValue, useContextProps } from 'react-aria-components';

import {
  Text as ReactAriaText,
  TextProps as ReactAriaTextProps,
} from 'react-aria-components';

import styles from './Description.module.scss';

export type DescriptionContextValue = {
  isCompact?: DescriptionProps['isCompact'];
};

export const DescriptionContext =
  createContext<ContextValue<DescriptionContextValue, HTMLSpanElement>>(null);

type DescriptionProps = ReactAriaTextProps & {
  /* Whether to render a compact version of the description with smaller typography. */
  isCompact?: boolean;
  /** Greys everything out and disables user interaction. */
  isDisabled?: boolean;
};

/**
 * A styled description message for form inputs.
 *
 * Merges context props from `DescriptionContext` (preferring local props).
 */
export const Description = (props: DescriptionProps) => {
  const [contextProps] = useContextProps(props, null, DescriptionContext);
  const { children, isCompact, isDisabled, ...domProps } = contextProps;

  return (
    <ReactAriaText
      {...domProps}
      className={styles.description}
      data-compact={isCompact}
      data-disabled={isDisabled}
      slot="description"
      data-zds
    >
      {children}
    </ReactAriaText>
  );
};
